import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IAccount } from "src/domain/entities"
import { accountDeleteService } from "src/domain/services/account/accountDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	account: IAccount
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const AccountDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	account,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleAccountDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await accountDeleteService({ id: account.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [account, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Account: ${account.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleAccountDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
